import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card/Card.jsx';
import NoResultsFoundMessage from '../NoResultsFoundMessage/NoResultsFoundMessage.jsx';

const NoResultsFoundCard = ({title, message, className, style}) => {
  return (
    <Card title={title} className={className} style={style}>
      <NoResultsFoundMessage message={message} />
    </Card>
  );
};

NoResultsFoundCard.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default NoResultsFoundCard;
